/*
 * Re-useable numeric text box with plus and minus button functionality.
 */
angular.module('qkr').directive('mcNumericInputRoll', ['$timeout', 'utils', 'gettextCatalog', function($timeout, utils, gettextCatalog) {
	return {
		require: 'ngModel',
		scope: {
			number: '=ngModel',
			maxValue: '=?',
			minValue: '=?',
			step: '=?',
			config: '=?',
			ngChange: '&?'
		},
		template: '<div class="numericContainer"><input type="text" numeric ng-model="number" ng-blur="checkValue()"><div class="buttonContainer"><div ng-mousedown="rollUpProxy()" ng-mouseup="endRoll()"><i class="fa fa-plus"></i></div><div ng-mousedown="rollDownProxy()" ng-mouseup="endRoll()"><i class="fa fa-minus"></i></div></div></div>',
		replace: true,
		link(scope, element, attrs, controller) {
			setDefaults();
			
			scope.rollTimeout = null;
			scope.numberOfStepsTaken = 0;
			scope.currentRollSpeed = scope.step;
			
			scope.rollUpProxy = function() {
				if (scope.number == null) {
					return;
				}
				
				const applicableRollInterval = getApplicableRollInterval(scope.config.rollIntervals, scope.numberOfStepsTaken);
				rollUp(applicableRollInterval);
				scope.rollTimeout = $timeout(scope.rollUpProxy, applicableRollInterval.interval);
			};
			
			scope.rollDownProxy = function() {
				if (scope.number == null) {
					return;
				}
				
				const applicableRollInterval = getApplicableRollInterval(scope.config.rollIntervals, scope.numberOfStepsTaken);
				rollDown(applicableRollInterval);
				scope.rollTimeout = $timeout(scope.rollDownProxy, applicableRollInterval.interval);
			};
			
			scope.endRoll = function() {
				$timeout.cancel(scope.rollTimeout);
				scope.numberOfStepsTaken = 0;
				scope.currentRollSpeed = scope.step;
				scope.checkValue();
			};
			
			scope.checkValue = function() {
				if (scope.number != null) {
					if (scope.minValue != null && (scope.number < scope.minValue)) {
						scope.number = scope.minValue;
					}
					
					if (scope.maxValue != null && (scope.number > scope.maxValue)) {
						scope.number = scope.maxValue;
					}
					
					if (scope.ngChange) {
						scope.ngChange();
					}
				}
			};
			
			// Validate changes to the directive's inputs
			scope.$watch('number', (newValue, oldValue) => {
                if (newValue != null) {
                	validateNumber(newValue);
                }
            });
			
			scope.$watch('maxValue', (newValue, oldValue) => {
                if (newValue != null) {
                	validateMaxValue(newValue);
                }
            });
			
			scope.$watch('minValue', (newValue, oldValue) => {
                if (newValue != null) {
                	validateMinValue(newValue);
                }
            });
			
			scope.$watch('step', (newValue, oldValue) => {
				if (newValue != null) {
					if (isNaN(newValue)) {
						scope.number = null;
						throw new Error(newValue + gettextCatalog.getString(' is not a valid step value'));
					}
				}
			});
			
			scope.$watch('config.rollIntervals', (newRollIntervals, oldRollIntervals) => {
				if (newRollIntervals != null) {
					// Verify validity of each user defined RollInterval
					angular.forEach(newRollIntervals, (rollInterval) => {
						if (rollInterval.atStep == null || isNaN(rollInterval.atStep)) {
							scope.number = null;
							throw new Error('Invalid RollInterval atStep value: ' + rollInterval.atStep);
						}
						
						if (rollInterval.interval == null || isNaN(rollInterval.interval)) {
							scope.number = null;
							throw new Error('Invalid RollInterval interval value: ' + rollInterval.interval);
						}
						
						if (rollInterval.stepMultiplier != null && isNaN(rollInterval.stepMultiplier)) {
							scope.number = null;
							throw new Error('Invalid RollInterval stepMultiplier value: ' + rollInterval.stepMultiplier);
						}
					});
				}
			});
			
			function setDefaults() {
				if (scope.number == null) {
					if (scope.minValue != null) {
						scope.number = scope.minValue;
					} else {
						scope.number = 0;
					}
				}
				
				if (scope.step == null) {
					scope.step = 1;
				}
				
				if (scope.config == null || scope.config.rollIntervals == null) {
					scope.config = {};
					scope.config.rollIntervals = [{atStep: 0, interval: 150, stepMultiplier: null}, {atStep: 5, interval: 100, stepMultiplier: null}, {atStep: 15, interval: 50, stepMultiplier: null}, {atStep: 30, interval: 25, stepMultiplier: null}, {atStep: 60, interval: 10, stepMultiplier: null}, {atStep: 120, interval: 1, stepMultiplier: null}];
				}
			}
			
			function validateNumber() {
				validateMaxValue(scope.maxValue);
				validateMinValue(scope.minValue);
			}
			
			function validateMaxValue(maxValue) {
				if (maxValue != null && scope.number != null) {
					if (scope.number > maxValue) {
						const value = scope.number;
						scope.number = null;
						throw new Error(gettextCatalog.getString('Value') + ' ' + value + gettextCatalog.getString('is greater than the max value of') + ' ' + maxValue);
					}
					
					if (maxValue <= scope.minValue) {
						scope.number = null;
						throw new Error(gettextCatalog.getString('Max value') + ' ' + maxValue + gettextCatalog.getString('must be greater than the min value of') + ' ' + scope.minValue);
					}
				}
			}
			
			function validateMinValue(minValue) {
				if (minValue != null && scope.number != null) {
					if (scope.number < minValue) {
						const value = scope.number;
						scope.number = null;
						throw new Error(gettextCatalog.getString('Value') + ' ' + value + gettextCatalog.getString('is less than the min value of') + minValue);
					}
					
					if (minValue >= scope.maxValue) {
						scope.number = null;
						throw new Error(gettextCatalog.getString('Min value') + ' ' + minValue + gettextCatalog.getString('must be less than the max value of') + ' ' + scope.maxValue);
					}
				}
			}
			
			function rollUp(applicableRollInterval) {
				scope.numberOfStepsTaken++;
				
				let step = scope.step;
				const numberOfDecimalPlaces = utils.getNumberOfDecimalPlaces(step);
				
				if (applicableRollInterval.stepMultiplier != null) {
					step = step * applicableRollInterval.stepMultiplier;
				}
				
				const newVal = Number(scope.number) + step;
				let roundedNewVal = utils.roundNumberToSpecifiedDecimalPlaces(newVal, numberOfDecimalPlaces);
				
				if (scope.maxValue != null) {
					if (scope.number >= scope.maxValue) {
						return;
					} else if (roundedNewVal >= scope.maxValue) {
						roundedNewVal = scope.maxValue;
					}
				}
				
				scope.number = roundedNewVal;
			}
			
			function rollDown(applicableRollInterval) {
				scope.numberOfStepsTaken++;
				
				let step = scope.step;
				const numberOfDecimalPlaces = utils.getNumberOfDecimalPlaces(step);
				
				if (applicableRollInterval.stepMultiplier != null) {
					step = step * applicableRollInterval.stepMultiplier;
				}
				
				const newVal = Number(scope.number) - step;
				let roundedNewVal = utils.roundNumberToSpecifiedDecimalPlaces(newVal, numberOfDecimalPlaces);
				
				if (scope.minValue != null) {
					if (scope.number <= scope.minValue) {
						return;
					} else if (roundedNewVal <= scope.minValue) {
						roundedNewVal = scope.minValue;
					}
				}
				
				scope.number = roundedNewVal;
			}
			
			function getApplicableRollInterval(rollIntervals, numberOfStepsTaken) {
				let applicableRollInterval = null;
				
				angular.forEach(rollIntervals, (rollInterval) => {
					if (numberOfStepsTaken >= rollInterval.atStep) {
						applicableRollInterval = rollInterval;
					}
				});
				
				return applicableRollInterval;
			}
		}
	};
}]);




// WEBPACK FOOTER //
// ./src/directives/numeric-input-roll.js